import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../universal-config';

@Injectable()
export class TasksManagerPlugin {

  gatewayUrl: string;
  staticAssetsPrefix: string;

  shareId: string;
  shareSecurityKey: string;
  tasksListsPromise: Promise<any>;

  constructor (
    public http: Http,
    public config: Config,
  ) {
    this.gatewayUrl = this.config.get('GATEWAY_URL');
    this.staticAssetsPrefix = `${ this.config.get('BOX_URL') }/file`;
  }

  setup(options: { shareId: string, shareSecurityKey: string }) {
    this.shareId = options.shareId;
    this.shareSecurityKey = options.shareSecurityKey;
  }

  async getReadOnlyTasksList (tasksListId: string): Promise<TasksListVM> {

    const tasksListResult = await this.readTasksLists();

    // TODO: Use normalizr for relation mappings
    return {
      // title: tasksListResult.taskList.title,
      title: tasksListResult.taskLists.find(tasksList => tasksList.globalId === tasksListId).title,
      tasks: tasksListResult.tasks.filter(task => task.taskListId === tasksListId).map(task => ({
        title: task.title,
        done: task.done,
        labels: tasksListResult.labels
          .filter(taskLabel => taskLabel.taskId === task.globalId)
          .map(taskLabel => {
            const relatedWorkspaceLabel = tasksListResult.workspaceLabels.find(workspaceLabel => workspaceLabel.globalId === taskLabel.labelId);
            if (!relatedWorkspaceLabel) {
              console.warn(`Workspace label was not found for label:`, taskLabel)
              return null;
            }
            return {
              // color: this.symanticColorToHex(relatedWorkspaceLabel.color),
              color: relatedWorkspaceLabel.color,
              title: relatedWorkspaceLabel.title
            }
          })
          .filter(Boolean),
        deadlineDate: (task.deadlineDate * 1000) || 0,
        assignees: tasksListResult.assignees
          .filter(assignee => assignee.taskId === task.globalId)
          .map(assignee => {
            const user = tasksListResult.users.find(user => user.id === assignee.userId);
            const avatar = tasksListResult.avatars.find(avatar => avatar.userId === assignee.userId);
            if (!user) {
              console.warn(`Member was not found for assignee:`, assignee)
              return null;
            }
            return {
              displayName: user.firstname,
              avatarUrl: avatar ? `${ this.staticAssetsPrefix }/${ avatar.storedFileUUID }` : null
            }
          })
          .filter(Boolean),
      })),
    }

  }

  private async readTasksLists(): Promise<ApiTasksListsResponse> {
    if (!this.tasksListsPromise) {
      this.tasksListsPromise = this.apiLoadTasksLists({
        shareId: this.shareId,
        shareSecurityKey: this.shareSecurityKey,
      })
    }
    return this.tasksListsPromise
  }

  private getCookie(keyName: string): string {
    const values = {}
    document.cookie.split('; ').forEach(item => {
      const [key, value] = item.split('=')
      values[key] = value
    })
    return values[keyName]
  }

  private async apiLoadTasksLists(options: { shareId: string, shareSecurityKey: string }): Promise<ApiTasksListsResponse> {
    const headers = new Headers({
       'x-session-id': this.getCookie('eversessionid'),
    });

    const response = await this.http.get(`${ this.gatewayUrl }/ft:tasks/shares/${ options.shareId }?securityKey=${ options.shareSecurityKey }`, {
      headers
    }).toPromise();
    return response.json();
    // return {"taskLists":[{"id":715,"globalId":"ILUk5v1TtkhvPYKR","title":"Task List 1","workspaceId":"258vzlhjrsugeu48","noteGlobalId":"BuV7tM42MY8qwwR3","userId":102,"lastUpdateUserId":102,"createdAt":1649350352,"updatedAt":1649350368,"order":["hob6ggchtx3fwvkk","5yt1tgq5sc2zcp30"],"clock":23,"deleted":false},{"id":716,"globalId":"5eDkrocoRJeSUX6S","title":"Task List 2","workspaceId":"258vzlhjrsugeu48","noteGlobalId":"BuV7tM42MY8qwwR3","userId":102,"lastUpdateUserId":102,"createdAt":1649350378,"updatedAt":1649350677,"order":["qq0dntrvagwc5ofs","vp8bakxijnbcdebx"],"clock":27,"deleted":false}],"notes":[{"globalId":"BuV7tM42MY8qwwR3","parentId":"default","createdAt":1649350293,"dateAdded":1649350294,"dateUpdated":1649353230,"updatedAt":1649353230,"type":"note","role":"note","title":"TEST TASKS FOR SHARE","url":"","locationLat":0,"locationLng":0,"shared":true,"favorite":false,"lastChangeBy":5,"cntNotes":0,"size":9,"editnote":true,"isEncrypted":false,"isCompleted":false,"workspaceId":"258vzlhjrsugeu48","isImported":false,"isFullwidth":false,"userId":102,"isReady":true,"outliner":true}],"tasks":[{"id":2087,"globalId":"hob6ggchtx3fwvkk","title":"Task 1","workspaceId":"258vzlhjrsugeu48","userId":102,"lastUpdateUserId":102,"taskListId":"ILUk5v1TtkhvPYKR","done":false,"deadlineDate":null,"createdAt":1649350366,"updatedAt":1649428083,"clock":86,"deleted":false},{"id":2088,"globalId":"5yt1tgq5sc2zcp30","title":"Task 2","workspaceId":"258vzlhjrsugeu48","userId":102,"lastUpdateUserId":102,"taskListId":"ILUk5v1TtkhvPYKR","done":false,"deadlineDate":1649869200,"createdAt":1649350368,"updatedAt":1649428080,"clock":85,"deleted":false},{"id":2089,"globalId":"qq0dntrvagwc5ofs","title":"Task 3","workspaceId":"258vzlhjrsugeu48","userId":102,"lastUpdateUserId":102,"taskListId":"5eDkrocoRJeSUX6S","done":true,"deadlineDate":null,"createdAt":1649350384,"updatedAt":1649352644,"clock":81,"deleted":false},{"id":2090,"globalId":"vp8bakxijnbcdebx","title":"Task 4","workspaceId":"258vzlhjrsugeu48","userId":102,"lastUpdateUserId":102,"taskListId":"5eDkrocoRJeSUX6S","done":false,"deadlineDate":1651179600,"createdAt":1649350677,"updatedAt":1649428077,"clock":84,"deleted":false}],"assignees":[{"workspaceId":"258vzlhjrsugeu48","taskId":"hob6ggchtx3fwvkk","createdAt":1649350681,"userId":102,"setByUserId":102,"clock":8,"deleted":false},{"workspaceId":"258vzlhjrsugeu48","taskId":"vp8bakxijnbcdebx","createdAt":1649350685,"userId":102,"setByUserId":102,"clock":9,"deleted":false}],"reminders":[{"globalId":"d6mzytyaa59tbf7b","workspaceId":"258vzlhjrsugeu48","taskId":"5yt1tgq5sc2zcp30","beforeValue":1,"beforeUnit":"hour","triggered":false,"createdAt":1649350804,"updatedAt":1649350804,"userId":102,"lastUpdateUserId":102,"clock":2,"deleted":false}],"labels":[{"workspaceId":"258vzlhjrsugeu48","taskId":"vp8bakxijnbcdebx","createdAt":1649350697,"labelId":"70emzb3ccjiihkuj","userId":102,"clock":8,"deleted":false},{"workspaceId":"258vzlhjrsugeu48","taskId":"hob6ggchtx3fwvkk","createdAt":1649350709,"labelId":"yjnpb0isp37ekcst","userId":102,"clock":9,"deleted":false},{"workspaceId":"258vzlhjrsugeu48","taskId":"hob6ggchtx3fwvkk","createdAt":1649350713,"labelId":"70emzb3ccjiihkuj","userId":102,"clock":10,"deleted":false}],"workspaceLabels":[{"globalId":"70emzb3ccjiihkuj","userId":102,"workspaceId":"258vzlhjrsugeu48","title":"уауа","color":"purple","style":"default","createdAt":1646832478,"updatedAt":1646832478,"clock":6,"deleted":false},{"globalId":"yjnpb0isp37ekcst","userId":102,"workspaceId":"258vzlhjrsugeu48","title":"plz god","color":"deep-orange","style":"default","createdAt":1649350708,"updatedAt":1649350708,"clock":8,"deleted":false}],"members":[{"globalId":"258vzmq437sx6s74","addedByUserId":102,"userId":102,"createdAt":1644509937,"updatedAt":1644509937,"workspaceId":"258vzlhjrsugeu48","type":"full","role":"admin","encryptRole":"encryptionManager","privileges":["canRead","canComment","canEdit","canManagePublicLinks","canAccessTrash","canManageTags","canDeleteNodes","canRenameFolders","canMoveNodes","canManageMembers","canAccessEncryptedNotes","canEncryptNotes","canManageEncryptionKeys"],"orgId":"u2u"},{"globalId":"258vzmq437sx6s74","addedByUserId":102,"userId":102,"createdAt":1644509937,"updatedAt":1644509937,"workspaceId":"258vzlhjrsugeu48","type":"full","role":"admin","encryptRole":"encryptionManager","privileges":["canRead","canComment","canEdit","canManagePublicLinks","canAccessTrash","canManageTags","canDeleteNodes","canRenameFolders","canMoveNodes","canManageMembers","canAccessEncryptedNotes","canEncryptNotes","canManageEncryptionKeys"],"orgId":"u2u"}],"users":[{"id":102,"firstname":"omg","lastname":"esrgserg","username":"omgnewcluster-34n6a555v"}],"avatars":[{"userId":102,"storedFileUUID":"721eb789-e05c-42c0-9558-0829fc2ab993","createdAt":1646410561,"updatedAt":1646411456}],"share":{"id":116,"securityKey":"n9vlo1tvs9ualbcrhvv2","dateUpdated":1649353230,"passwordRequired":false,"accessAllowed":true,"noteGlobalId":"BuV7tM42MY8qwwR3","userId":102,"note":{"globalId":"BuV7tM42MY8qwwR3","parentId":"default","createdAt":1649350293,"dateAdded":1649350294,"dateUpdated":1649353230,"updatedAt":1649353230,"type":"note","role":"note","title":"TEST TASKS FOR SHARE","url":"","locationLat":0,"locationLng":0,"shared":true,"favorite":false,"lastChangeBy":5,"cntNotes":0,"size":9,"editnote":true,"attachments":[],"todos":[],"todosOrder":[],"text":{"noteGlobalId":"BuV7tM42MY8qwwR3","text":"test\ntest","textShort":"test test","length":9,"dateUpdated":1649350293,"version":2,"nodeId":"0-0","stateSet":"\"{\\\"ss\\\":[[1618519032,32],[3088688242,43]],\\\"ds\\\":[[1618519032,25,1],[1618519032,29,2],[3088688242,8,1],[3088688242,13,1],[3088688242,36,1],[3088688242,41,1]]}\""},"isEncrypted":false,"isCompleted":false,"workspaceId":"258vzlhjrsugeu48","isImported":false,"isFullwidth":false,"userId":102,"isReady":true,"outliner":true},"workspaceId":"258vzlhjrsugeu48","orgTitle":"new-cluster","accessControl":"public","org":{"globalId":"u2u","userId":102,"orgType":"private","title":"new-cluster","domain":"","sub":"new-cluster","smallLogoStoredFileUUID":null,"bigLogoStoredFileUUID":null}}}
  }

  private symanticColorToHex(colorName: string) {
    return '#000';
  }

}

// API RESPONSES

export interface ApiTasksListsResponse {
  assignees: ApiAssigneeDto[];
  avatars: ApiAvatarDto[];
  labels: ApiLabelDto[];
  members: ApiMemberDto[];
  notes: ApiNoteDto[];
  reminders: ApiReminderDto[];
  taskLists: ApiTasksListDto[];
  tasks: ApiTaskDto[];
  users: ApiUserDto[];
  workspaceLabels: ApiWorkspaceLabelDto[];
}

// API MODELS

export interface ApiNoteDto {
  globalId: string;
  parentId: string;
  createdAt: number;
  dateAdded: number;
  dateUpdated: number;
  updatedAt: number;
  type: string;
  role: string;
  title: string;
  url: string;
  locationLat: number;
  locationLng: number;
  shared: boolean;
  favorite: boolean;
  lastChangeBy: number;
  cntNotes: number;
  size: number;
  editnote: boolean;
  isEncrypted: boolean;
  isCompleted: boolean;
  workspaceId: string;
  isImported: boolean;
  isFullwidth: boolean;
  userId: number;
  isReady: boolean;
  outliner: boolean;
}

export interface ApiTasksListDto {
  id: number;
  globalId: string;
  title: string;
  workspaceId: string;
  noteGlobalId: string;
  userId: number;
  lastUpdateUserId: number;
  createdAt: number;
  updatedAt: number;
  order: string[];
  clock: number;
  deleted: boolean;
}

export interface ApiTaskDto {
  id: number;
  globalId: string;
  title: string;
  workspaceId: string;
  userId: number;
  lastUpdateUserId: number;
  taskListId: string;
  done: boolean;
  deadlineDate: number | null;
  createdAt: number;
  updatedAt: number;
  clock: number;
  deleted: boolean;
}

export interface ApiAssigneeDto {
  workspaceId: string;
  taskId: string;
  createdAt: number;
  userId: number;
  setByUserId: number;
  clock: number;
  deleted: boolean;
}

export interface ApiReminderDto {
  globalId: string;
  workspaceId: string;
  taskId: string;
  beforeValue: number;
  beforeUnit: string;
  triggered: boolean;
  createdAt: number;
  updatedAt: number;
  userId: number;
  lastUpdateUserId: number;
  clock: number;
  deleted: boolean;
}

export interface ApiLabelDto {
  workspaceId: string;
  taskId: string;
  createdAt: number;
  labelId: string;
  userId: number;
  clock: number;
  deleted: boolean;
}

export interface ApiWorkspaceLabelDto {
  globalId: string;
  userId: number;
  workspaceId: string;
  title: string;
  color: string;
  style: string;
  createdAt: number;
  updatedAt: number;
  clock: number;
  deleted: boolean;
}

export interface ApiUserDto {
  id: number,
  firstname: string,
  lastname: string,
  username: string,
}

export interface ApiAvatarDto {
  userId: number,
  storedFileUUID: string,
  createdAt: number,
  updatedAt: number,
}

export interface ApiMemberDto {
  globalId: string,
  addedByUserId: number,
  userId: number,
  createdAt: number,
  updatedAt: number,
  workspaceId: string,
  type: string,
  role: string,
  encryptRole: string,
  privileges: string[],
  orgId: string,
}

// EDITOR'S VIEW MODELS

export interface TasksListVM {
  title: string;
  tasks: TaskVM[];
}

export interface TaskVM {
  title: string;
  done: boolean;
  deadlineDate: number;
  labels: LabelVM[];
  assignees: UserVM[];
}

export interface LabelVM {
  title: string;
  color: string;
}

export interface UserVM {
  displayName: string;
  avatarUrl?: string;
}
